import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { Container, Text } from "@pixi/react";
import { TextStyle } from "pixi.js";
import { useDimensions } from "../../../../Contexts/DimensionsContext";
import { Settings } from "../../../../settings";
import { PixiSettings } from "../../../../pixiSettings";
import {
  FONT_CONFIG,
  USER_INTERFACE_BUTTON_CONFIG,
  TEXT_STYLE_CONFIG,
} from "../../../../textureConfigs";

// Extend dayjs with timezone plugins
dayjs.extend(utc);
dayjs.extend(timezone);

const PopiClock = ({ timeZone = "Europe/Belgrade", toolbar }) => {
  const { device, orientation, getResponsiveConfig, uiSymbolScale } =
    useDimensions();
  const [time, setTime] = useState(dayjs());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(dayjs());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Format the time string
  const baseFontSize = 28;
  const formattedTime = `${Settings.APP.GAME_NAME_FULL} | ${time
    .tz(timeZone)
    .format("HH:mm")}`;

  // Get button dimensions using the same system as PixiButtonSound
  const buttonConfig = getResponsiveConfig(USER_INTERFACE_BUTTON_CONFIG, true);

  // Get unified clock configuration (font multiplier, x, y positions)
  const getClockConfig = () => {
    let fontMultiplier = 1.0;
    let x = 0;
    let y = 0;

    if (device === PixiSettings.DEVICE.MOBILE) {
      if (orientation === PixiSettings.ORIENTATION.PORTRAIT) {
        fontMultiplier = 1.0;
        x = toolbar.width / 2;
        y = buttonConfig.height * 0.3;
      } else {
        fontMultiplier = 1.0;
        x = buttonConfig.width * 2.9;
        y = buttonConfig.height * 0.785;
      }
    } else if (device === PixiSettings.DEVICE.TABLET) {
      if (orientation === PixiSettings.ORIENTATION.PORTRAIT) {
        fontMultiplier = 1.55;
        x = toolbar.width / 2;
        y = buttonConfig.height * 0.3;
      } else {
        fontMultiplier = 1.1;
        x = toolbar.width / 2;
        y = buttonConfig.height * 0.4;
      }
    } else {
      // Desktop
      fontMultiplier = 1.0;
      x = toolbar.width - buttonConfig.width * 4.25;
      y = buttonConfig.height * 0.785;
    }

    return { fontMultiplier, x, y };
  };

  const clockConfig = getClockConfig();
  const responsiveFontSize = baseFontSize * clockConfig.fontMultiplier;
  const FONT_SIZE = Math.round(responsiveFontSize * uiSymbolScale);

  const popiClockStyle = new TextStyle({
    fontFamily: FONT_CONFIG.PRIMARY,
    fontSize: FONT_SIZE,
    fontWeight: "600",
    fill: 0xffffff,
    align: "center",
    ...TEXT_STYLE_CONFIG.OUTLINE, // Black outline with 0.5 opacity and 2px thickness
  });

  const popiClockPosition = {
    x: Math.round(clockConfig.x),
    y: Math.round(clockConfig.y),
  };

  return (
    <Container
      name="secondary_clock"
      x={popiClockPosition.x}
      y={popiClockPosition.y}
      zIndex={3}
    >
      <Text
        text={formattedTime}
        style={popiClockStyle}
        anchor={0.5}
        x={0}
        y={0}
        resolution={2}
      />
    </Container>
  );
};

export default PopiClock;
